<template>
  <fieldset class="list-group">
    <input type="hidden" value="" :name="inputName" v-if="newItems.length === 0" />
    <input :type="itemType" class="list-group-item form-control" :name="inputName" v-model="item.value"
      v-for="(item, index) in newItems" :key="index" @blur="handleBlur(item)" @keypress="handlePress"
      :pattern="itemPattern" />
    <input :type="itemType" class="list-group-item form-control" @input="handleNew" :placeholder="placeholder"
      v-model="newItem" ref="newItem" />
  </fieldset>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "@/types";

export default defineComponent({
  name: "StringArray",
  props: {
    objectName: {
      type: String,
      required: true,
    },
    attributeName: {
      type: String,
      required: true,
    },
    itemType: {
      type: String,
      default: "text",
    },
    itemPattern: {
      type: String,
      default: null,
    },
    items: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  computed: {
    inputName() {
      return `${this.objectName}[${this.attributeName}][]`;
    },
  },
  data() {
    return {
      newItems: this.items.map((item: string) => ({ value: item })),
      newItem: "",
    };
  },
  methods: {
    handleNew() {
      if (this.newItem.trim().length > 0) {
        this.newItems.push({ value: this.newItem.trim() });
        this.newItem = "";
        this.$nextTick(() => {
          this.$refs.newItem.previousElementSibling.focus();
        });
      }
    },
    handlePress(event: any) {
      if (event.keyCode === 13) {
        event.preventDefault();
        if (event.target.reportValidity()) {
          event.target.nextElementSibling.focus();
        }
      }
    },
    handleBlur(item: any) {
      if (item.value.trim() === "") {
        this.newItems.splice(this.newItems.indexOf(item), 1);
      }
    },
  },
});
</script>
